import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import "./ModernModal.css";
import SuccessPopup from "./popup/SuccessPopup";

const ModernModal = ({
  open,
  title,
  width = "480px",
  children,
  onOk,
  onCancel,
  okText = "Confirm",
  cancelText = "Cancel",
  showFooter = true,
}) => {
  return (
    <AnimatePresence>
      {open && (
        <>
          {/* BACKDROP */}
          <motion.div
            className="mm-backdrop"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          ></motion.div>

          {/* MODAL */}
          <motion.div
            className="mm-container"
            initial={{ opacity: 0, scale: 0.8, y: 30 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.8, y: 30 }}
            transition={{ duration: 0.25, ease: "easeOut" }}
            style={{ maxWidth: width }}
          >
            <h2 className="mm-title">{title}</h2>

            <div className="mm-content">{children}</div>

            {showFooter && (
              <div className="mm-footer">
                <button className="mm-btn cancel" onClick={onCancel}>
                  {cancelText}
                </button>

                <button className="mm-btn ok" onClick={onOk}>
                  {okText}
                </button>
                {/* <SuccessPopup
                  open={open}
                  onClose={onCancel}
                  message={title}
                  navigate={onOk}
                /> */}
              </div>
            )}
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};

export default ModernModal;
